"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.togglePostReactionArgsValidator = exports.togglePostReactionArgsSchema = exports.refCollectionToRefTypeMap = exports.reactionToPluralMap = exports.updatePostArgsValidator = exports.updatePostArgsSchema = exports.deletePostArgsValidator = exports.deletePostArgsSchema = void 0;
var channel_1 = require("../channel");
var issue_1 = require("./issue");
var answer_1 = require("./answer");
// import {UpdateCommentArgs, updateCommentArgsSchema} from "./comment";
// import {UpdateProposalArgs, updateProposalArgsSchema} from "./proposal";
// import {UpdateSubCommentArgs, updateSubCommentArgsSchema} from "./subComment";
var suretype_1 = require("suretype");
// --------------------------
// delete
// --------------------------
exports.deletePostArgsSchema = suretype_1.v.object({
    // cmd: v.string().const("deletePost").required(),
    channel: channel_1.channelReferenceInfoSchemaSureType.required(),
    // relative path to document inside channel
    // e.g.: relPath = "issues/{issueId}/answers/{answerId}
    relPath: suretype_1.v.string().required(),
    global: suretype_1.v.boolean().required(),
});
exports.deletePostArgsValidator = (0, suretype_1.compile)(exports.deletePostArgsSchema);
// --------------------------
// update post
// --------------------------
// export interface UpdatePostArgs {
//     channel: ChannelReferenceInfo,
//     // relative path to document inside channel
//     // e.g.: relPath = "issues/{issueId}/answers/{answerId}
//     relPath: string,
//     postUpdate: UpdateIssueArgs | UpdateAnswerArgs | UpdateCommentArgs | UpdateSubCommentArgs | UpdateProposalArgs
// }
exports.updatePostArgsSchema = suretype_1.v.object({
    // cmd: v.string().const("updatePost").required(),
    channel: channel_1.channelReferenceInfoSchemaSureType.required(),
    relPath: suretype_1.v.string().required(),
    postUpdate: suretype_1.v.anyOf([
        issue_1.updateIssueArgsSchema, answer_1.updateAnswerArgsSchema
    ]).required(),
    global: suretype_1.v.boolean().required()
});
exports.updatePostArgsValidator = (0, suretype_1.compile)(exports.updatePostArgsSchema);
// --------------------------
// toggle channel reaction
// --------------------------
exports.reactionToPluralMap = {
    "upVote": "upVotes"
};
exports.refCollectionToRefTypeMap = {
    "issues": "issue",
    "answers": "answer",
    "proposals": "proposal",
    "comments": "comment",
    "subComments": "subComment"
};
exports.togglePostReactionArgsSchema = suretype_1.v.object({
    // cmd: v.string().const("togglePostReaction").required(),
    channel: channel_1.channelReferenceInfoSchemaSureType.required(),
    relPath: suretype_1.v.string().required(),
    reaction: suretype_1.v.string().enum("upVote").required(),
    value: suretype_1.v.boolean().required(),
    global: suretype_1.v.boolean().required(),
});
exports.togglePostReactionArgsValidator = (0, suretype_1.compile)(exports.togglePostReactionArgsSchema);
